export default "__VITE_ASSET__7b6e4d7e__"